import { makeAutoObservable } from 'mobx'
import { Effect } from './utils/Effect'
import { RequestHelper } from './utils/RequestHelper'
import ApiClient from '../api'
import { AreasStore } from './areas.store'

export type OwnerMembersSortBy = 'registeredAt' | 'balance' | 'lastVisitAt'
export type OwnerMembersSortDir = 'asc' | 'desc'

const DEFAULT_SORT_BY: OwnerMembersSortBy = 'registeredAt'
const DEFAULT_SORT_DIR: OwnerMembersSortDir = 'desc'
const DEFAULT_PAGE_SIZE = 20

// Owner-only список мемберов с балансами. Пагинация, сортировка и поиск — на сервере.
class OwnerMembersStoreClass {
  search = ''

  pageNumber = 1

  pageSize = DEFAULT_PAGE_SIZE

  sortBy: OwnerMembersSortBy = DEFAULT_SORT_BY

  sortDir: OwnerMembersSortDir = DEFAULT_SORT_DIR

  constructor() {
    makeAutoObservable(this)
  }

  loadEffect = new Effect(
    (request) =>
      RequestHelper.unwrapFromFetchResponse(ApiClient().ownerMembers.postApiV1OwnerMembers(request)),
    'Loading Members',
    true
  )

  load = () =>
    this.loadEffect.run({
      areaId: AreasStore.selectedAreaId,
      pageNumber: this.pageNumber,
      pageSize: this.pageSize,
      search: this.search || null,
      sortBy: this.sortBy,
      sortDir: this.sortDir,
    })

  reset = () => {
    this.search = ''
    this.pageNumber = 1
    this.pageSize = DEFAULT_PAGE_SIZE
    this.sortBy = DEFAULT_SORT_BY
    this.sortDir = DEFAULT_SORT_DIR
  }

  setSearch = (search: string) => {
    this.search = search
    this.pageNumber = 1
  }

  // Без аргументов — сортировка по умолчанию (регистрация, новые сверху).
  setSort = (sortBy?: OwnerMembersSortBy, sortDir?: OwnerMembersSortDir) => {
    this.sortBy = sortBy ?? DEFAULT_SORT_BY
    this.sortDir = sortDir ?? DEFAULT_SORT_DIR
    this.pageNumber = 1
  }

  setPage = (pageNumber: number, pageSize: number) => {
    if (pageSize !== this.pageSize) {
      this.pageSize = pageSize
      this.pageNumber = 1
      return
    }
    this.pageNumber = pageNumber
  }

  get items() {
    return this.loadEffect.data?.items ?? []
  }

  get totalCount() {
    return this.loadEffect.data?.totalCount ?? 0
  }
}

export const OwnerMembersStore = new OwnerMembersStoreClass()
